import React from "react";
import {useOverrides, Override} from "@quarkly/components";
import {Text, Box, Link, Section} from "@quarkly/widgets";

const defaultProps = {
    "padding": "50px 0 80px 0",
    "quarkly-title": "CdzvOtherSites",
    "background": "--color-light",
    "display": "flex"
};

const overrides = {
    "text": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 60px 0px",
            "font": "normal 700 56px/1.3 --fontFamily-sans",
            "text-align": "center",
            "color": "--dark",
            "children": "CDZV Ecosystem - Everything for Traders"
        }
    },
    "container": {
        "kind": "Box",
        "props": {
            "display": "grid",
            "grid-template-columns": "repeat(2, 1fr)",
            "grid-gap": "30px",
            "width": "100%",
            "max-width": "1200px",
            "margin": "0 auto",
            "padding": "0 20px",
            "md-grid-template-columns": "1fr",
            "md-grid-gap": "20px"
        }
    },
    "card1": {
        "kind": "Box",
        "props": {
            "padding": "40px 30px",
            "background": "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            "border-radius": "16px",
            "box-shadow": "0 10px 30px rgba(0, 0, 0, 0.15)",
            "transition": "transform 0.3s ease, box-shadow 0.3s ease",
            "hover-transform": "translateY(-5px)",
            "hover-box-shadow": "0 15px 40px rgba(0, 0, 0, 0.2)",
            "display": "flex",
            "flex-direction": "column",
            "align-items": "flex-start"
        }
    },
    "card2": {
        "kind": "Box",
        "props": {
            "padding": "40px 30px",
            "background": "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
            "border-radius": "16px",
            "box-shadow": "0 10px 30px rgba(0, 0, 0, 0.15)",
            "transition": "transform 0.3s ease, box-shadow 0.3s ease",
            "hover-transform": "translateY(-5px)",
            "hover-box-shadow": "0 15px 40px rgba(0, 0, 0, 0.2)",
            "display": "flex",
            "flex-direction": "column",
            "align-items": "flex-start"
        }
    },
    "cardTitle1": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 15px 0px",
            "font": "normal 700 32px/1.2 --fontFamily-sans",
            "color": "white",
            "children": "📊 CDZV.TRADE - Proof of Efficiency"
        }
    },
    "cardTitle2": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 15px 0px",
            "font": "normal 700 32px/1.2 --fontFamily-sans",
            "color": "white",
            "children": "🎓 CDZV.CLUB - Community & Education"
        }
    },
    "cardDescription1": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 25px 0px",
            "font": "normal 400 18px/1.6 --fontFamily-sans",
            "color": "rgba(255, 255, 255, 0.9)",
            "children": "Real results of our trading strategies. Live statistics from exchange pools. Transparent performance in real-time. See the proof before you invest."
        }
    },
    "cardDescription2": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 25px 0px",
            "font": "normal 400 18px/1.6 --fontFamily-sans",
            "color": "rgba(255, 255, 255, 0.9)",
            "children": "Closed community of professional traders. Exclusive educational materials and webinars. Networking with top traders. For those who want to learn from the best."
        }
    },
    "link1": {
        "kind": "Link",
        "props": {
            "href": "https://cdzv.trade/",
            "target": "_blank",
            "padding": "14px 32px",
            "background": "white",
            "color": "#667eea",
            "border-radius": "10px",
            "font": "normal 600 17px/1.5 --fontFamily-sans",
            "text-decoration": "none",
            "transition": "all 0.3s ease",
            "hover-background": "rgba(255, 255, 255, 0.95)",
            "hover-transform": "scale(1.03)",
            "hover-box-shadow": "0 8px 20px rgba(102, 126, 234, 0.25)",
            "display": "inline-block",
            "box-shadow": "0 4px 12px rgba(0, 0, 0, 0.08)",
            "children": "Visit CDZV.Trade →"
        }
    },
    "link2": {
        "kind": "Link",
        "props": {
            "href": "http://cdzv.club/",
            "target": "_blank",
            "padding": "14px 32px",
            "background": "white",
            "color": "#f5576c",
            "border-radius": "10px",
            "font": "normal 600 17px/1.5 --fontFamily-sans",
            "text-decoration": "none",
            "transition": "all 0.3s ease",
            "hover-background": "rgba(255, 255, 255, 0.95)",
            "hover-transform": "scale(1.03)",
            "hover-box-shadow": "0 8px 20px rgba(245, 87, 108, 0.25)",
            "display": "inline-block",
            "box-shadow": "0 4px 12px rgba(0, 0, 0, 0.08)",
            "children": "Visit CDZV.Club →"
        }
    }
};

const CdzvOtherSites = props => {
    const {
        override,
        children,
        rest
    } = useOverrides(props, overrides, defaultProps);

    return <Section {...rest}>
        <Override slot="SectionContent" max-width="1280px"/>
        <Text {...override("text")} />
        <Box {...override("container")}>
            <Box {...override("card1")}>
                <Text {...override("cardTitle1")} />
                <Text {...override("cardDescription1")} />
                <Link {...override("link1")} />
            </Box>
            <Box {...override("card2")}>
                <Text {...override("cardTitle2")} />
                <Text {...override("cardDescription2")} />
                <Link {...override("link2")} />
            </Box>
        </Box>
        {children}
    </Section>;
};

Object.assign(CdzvOtherSites, {
    ...Section,
    defaultProps,
    overrides
});

export default CdzvOtherSites;
